const initialState = {
  offers: [],
  allItems: [],
  allLabels: [],
  isFetching: false,
  loading: false,
};

const offerReducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH OFFERS
    case "FETCH_OFFERS_REQUEST":
      return { ...state, isFetching: true };

    case "FETCH_OFFERS_SUCCESS":
      return { ...state, isFetching: false, offers: action.payload };

    case "FETCH_OFFERS_ERROR":
      return { ...state, isFetching: false };

    // ADD OFFER
    case "ADD_OFFER_REQUEST":
      return { ...state, loading: true };

    case "ADD_OFFER_SUCCESS":
      return {
        ...state,
        loading: false,
      };

    case "ADD_OFFER_ERROR":
      return { ...state, loading: false };

    // DELETE OFFER
    case "DELETE_OFFER_REQUEST":
      return { ...state, loading: true };

    case "DELETE_OFFER_SUCCESS":
      return {
        ...state,
        loading: false,
        offers: state.offers.filter((offer) => offer.id !== action.payload),
      };

    case "DELETE_OFFER_ERROR":
      return { ...state, loading: false };

    // UPDATE OFFER
    case "UPDATE_OFFER_REQUEST":
      return { ...state, loading: true };

    case "UPDATE_OFFER_SUCCESS":
      return {
        ...state,
        loading: false,
        offers: state.offers.map((offer) =>
          offer.id === action.payload.id ? action.payload : offer
        ),
      };

    case "UPDATE_OFFER_ERROR":
      return { ...state, loading: false };

    case "FETCH_ITEMS":
      return { ...state, allItems: action.payload };

    case "FETCH_LABELS":
      return { ...state, allLabels: action.payload };

    default:
      return state;
  }
};

export default offerReducer;
